import { useEffect, useState } from 'react';
import { siteConfig } from '../siteConfig';

const QUERY = '(prefers-reduced-motion: reduce)';

const supportsMatchMedia = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function';

const prefersReduced = () => supportsMatchMedia() && window.matchMedia(QUERY).matches;

export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(() => siteConfig.reduceMotion || prefersReduced());

  useEffect(() => {
    if (siteConfig.reduceMotion || !supportsMatchMedia()) return;

    const mq = window.matchMedia(QUERY);
    const onChange = () => setReduced(mq.matches);

    setReduced(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
